export class UnknownURI {
  type: string;
  uri: string;

  static parse(text: string) {
    const [, type] = text.split(":").map(decodeURIComponent);
    return new UnknownURI(type, text);
  }

  constructor(type: string, uri: string) {
    this.type = type;
    this.uri = uri;
  }

  toString() {
    return this.uri;
  }
}
